require('./dependencies.js');

/**
 * Home Group Safety Portal JS Include
 *
 * @author Strange Animals <info@strangeanimals.com.au>
 */

$(document).ready(function() {

    const emergencyDetailsElement = document.getElementById('EmergencyDetails');
    const toggleButtonElement = document.getElementById('ToggleDetails');
    const covidForm = document.getElementById('TotemForm_CovidRegisterForm');

    if (emergencyDetailsElement) {
        // Initialise hidden attribute on #EmergencyDetails element above 960px window width
        if ($(window).width() >= 960) {
            emergencyDetailsElement.hidden = true;
        }

        // Toggle hidden attribute on #EmergencyDetails
        $(window).resize(function() {
            if ($(window).width() >= 960) {
                if (toggleButtonElement.getAttribute('aria-expanded') == 'false' && emergencyDetailsElement.getAttribute('hidden') == null) {
                    emergencyDetailsElement.hidden = true;
                }
            } else if ($(window).width() < 960 && emergencyDetailsElement.getAttribute('hidden') !== null) {
                // If #EmergencyDetails is hidden, remove attribute if user resizes window < 960px
                emergencyDetailsElement.hidden = false;
            } else if (toggleButtonElement.getAttribute('aria-expanded') == 'true') {
                // If #EmergencyDetails is open, reset button if user resizes window < 960px;
                toggleButtonElement.setAttribute('aria-expanded', 'false');
                toggleButtonElement.innerHTML = "Show";
                toggleButtonElement.classList.add('hide-details');
            }
        });
    }

    if (toggleButtonElement) {
        // Toggle button text for Emergency Response Details
        $(toggleButtonElement).click(function () {
            if (toggleButtonElement.classList.contains('hide-details')) {
                toggleButtonElement.innerHTML = "Hide";
                toggleButtonElement.classList.remove('hide-details');
            }
            else {
                toggleButtonElement.innerHTML = "Show";
                toggleButtonElement.classList.add('hide-details');
            }
        })
    }

    // covid registrar
    if (covidForm) {
        const covidSuccessContainer = document.getElementById('CovidSuccessContainer');
        const covidFormSubmit = document.getElementById('TotemForm_CovidRegisterForm_action_processCovidRegisterForm');
        const covidResponses = {
            yes: covidForm.querySelector('#CovidStatus button[data-val="yes"]'),
            no: covidForm.querySelector('#CovidStatus button[data-val="no"]')
        };
        const covidNoDeclaration = covidForm.querySelector('#CovidNoDeclaration');
        const covidValueField = covidForm.querySelector('#TotemForm_CovidRegisterForm_CovidValue');
        let covidResponse = null;

        let hasKendo = !!$(covidForm).kendoValidator;
        let validator;

        if (hasKendo) {
            validator = $(covidForm).kendoValidator().data("kendoValidator");
        }

        const setCovidValueFunc = (covidValue) => {
            covidValueField.value = null;

            switch (covidResponse) {
                case 'yes':
                    covidValueField.value = covidValue;
                    covidFormSubmit.removeAttribute('disabled');
                    covidNoDeclaration.classList.add('uk-hidden');

                    covidResponses.yes.classList.add('active');
                    covidResponses.no.classList.remove('active');
                    break;

                case 'no':
                    covidFormSubmit.setAttribute('disabled', 'disabled');
                    covidNoDeclaration.classList.remove('uk-hidden');

                    covidResponses.no.classList.add('active');
                    covidResponses.yes.classList.remove('active');
                    break;

                default:
                    covidFormSubmit.setAttribute('disabled', 'disabled');
                    covidNoDeclaration.classList.add('uk-hidden');

                    covidResponses.yes.classList.remove('active');
                    covidResponses.no.classList.remove('active');
                    break;
            }
        };

        const covidClickFunc = (e) => {
            covidResponse = e.srcElement.getAttribute('data-val');
            setCovidValueFunc(covidResponse);
        };

        for (let covidResponse in covidResponses) {
            covidResponses[covidResponse].addEventListener('click', covidClickFunc);
        }

        $(covidForm).submit((e) => {
            e.preventDefault();
            if (hasKendo ? validator.validate() : covidForm.checkValidity()) {
                $.ajax({
                    url: covidForm.action,
                    type: 'POST',
                    data: $(covidForm).serialize(),
                    success: function (resp) {
                        covidForm.classList.add('uk-hidden');
                        if (covidSuccessContainer) {
                            covidSuccessContainer.classList.remove('uk-hidden');
                            covidSuccessContainer.innerHTML = "<div class='alert-container success'><p>Your submission was successful. Have a good day!</p></div>";
                        }
                    },
                    error: function (resp) {
                        covidForm.classList.add('uk-hidden');
                        if (covidSuccessContainer) {
                            covidSuccessContainer.classList.remove('uk-hidden');
                            covidSuccessContainer.innerHTML = "<div class='alert-container fail'><p>Your submission was not successful. Please let your site supervisor know you were unable to complete the declaration.</p></div><button class='refresh-btn' onClick=\"window.location.reload();\">Retry</button>";
                        }
                    }
                });
            }
        });

        setCovidValueFunc(null);
    }
});